<template>
  <master-main
    :route="getModuleRoute"
    :addProperties="{
      eventType: 1,
      routeToCreate: getModuleRoute,
    }"
    :tableProperties="tableProperties"
    :exportProperties="{
      pdf: {
        filename: `${$t('labor.activities_value')}..pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('labor.activities_value')}..xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 300,
      },
      {
        columnLabel: $t('common_words.farm'),
        data: 'farms',
        property: 'name',
        minWidth: 200,
      },
      {
        columnLabel: $t('common_words.allotments'),
        data: 'lots',
        property: 'name',
        minWidth: 150,
      },
    ]"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    @refresh="refresh"
  ></master-main>
</template>
<script>
import ValuesTable from './activity-values-table';
import i18n from 'src/i18n';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  components: { MasterMain },
  data() {
    return {
      tableProperties: {},
    };
  },
  computed: {
    getModuleRoute() {
      return 'works/activityvalues';
    },
    buildTableProperties() {
      return {
        tableColumns: [...ValuesTable().tableColumns],
        howMuchTimePassed: ['start_date', 1, 'months'],
        effectTags: 'dark',
        model: 'activityvalue',
        addColumns: [
          {
            label: i18n.t('common_words.farms2'),
            data: 'farms',
            field: 'name',
          },
          {
            label: i18n.t('common_words.allotment(s)'),
            data: 'lots',
            field: 'name',
          },
        ],
      };
    },
  },
  mixins: [MixinAlert, MixinLoading, MixinMain, MixinPermissions],
};
</script>
